<template>
  <card-panel class="looking-for-jobs-container">
    <span v-translate slot="header-name" class="header">Looking for jobs?</span>
    <div v-if="profileLoadingState" slot="content" class="loader"></div>
    <div v-else slot="content">
      <p v-translate class="description">
        Also looking for new opportunities? Let us know!
      </p>
      <b-checkbox
        v-model="profileDetailsState.is_applicant"
        @change.native="updateApplicantStatus(!profileDetailsState.is_applicant)">
        <span v-translate>I'm open to opportunities</span>
      </b-checkbox>
    </div>
  </card-panel>
</template>

<script>

import CardPanel from 'top20common/components/card-panel/CardPanel';
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters(['profileDetailsState', 'profileLoadingState', 'isQuestionnaireFilled']),
    enrolledCandidateLabel() {
      return this.$gettext('You have enrolled as a candidate');
    }
  },
  methods: {
    updateApplicantStatus(isApplicant) {
      if (isApplicant) {
        this.$toast.open({message: this.enrolledCandidateLabel, type: 'is-success'});
      }
      this.$store.dispatch('updateCandidateIsApplicantAction', {is_applicant: isApplicant}).then(() => {
        if (!this.isQuestionnaireFilled && isApplicant) {
          this.$router.push({name: 'questionnaire'});
        }
      });
    }
  },
  components: {
    CardPanel
  }
};
</script>

<style lang="scss" scoped>
.looking-for-jobs-container {
  .description {
    padding-bottom: 25px;
  }
}
</style>
